import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";



export class master {



    constructor(){
    this.id=null;
    this.fyId=null;
    this.user=new user();
    this.quarter='';
    this.status='';
    this.misDetails=new misDetails();
    }
    id:number;
    fyId: number;
    user: any;
    quarter: string;
    status: string;
    misDetails: misDetails;
}
    
    
    export class Business
    {

        constructor(){
            this.newClient=[new newClient()];
            this.newAssignmentForExistingClient=[new newAssignmentForExistingClient()];
            this.clientsOrAssignmentDiscontinued=[new clientsOrAssignmentDiscontinued()];
            this.feesIncreasedOrDecreased=[new feesIncreasedOrDecreased()];
            this.potentialClientOrAssignment=[new potentialClientOrAssignment()];
        }

        newClient:newClient[]
        newAssignmentForExistingClient:newAssignmentForExistingClient[]
        clientsOrAssignmentDiscontinued:clientsOrAssignmentDiscontinued[]
        feesIncreasedOrDecreased:feesIncreasedOrDecreased[]
        potentialClientOrAssignment:potentialClientOrAssignment[]
    }

    export class user{

        constructor(){
            this.email='';
            this.firstName='';
            this.id=null;
            this.lastName='';
            this.middleName='';
            this.userId='';
        }

        email: string;
        firstName:string
        id:number
        lastName:string
        middleName:string
        userId:string
    }

    export class misDetails{
        constructor(){

            this.business=new Business();
            this.financialsData=[new financialsData()];
            this.engagementPerformance=[new engagementPerformance()];
            this.financialInterests= new financialInterests();
            this.materialIssues=[new materialIssues()];
            this.independence=[new independence()];
            this.training=new training();
        }

        financialsData:financialsData[]
        business: Business
        engagementPerformance: engagementPerformance[]
        financialInterests:financialInterests
        materialIssues:materialIssues[]
        independence:independence[]
        training:training
    }

    export class financialsData {

        constructor(){
                this.id=null;
                this.questionNo=null;
                this.particulars='';
                this.amount=null;
                this.isRequired=false;
                this.remark='';
                this.variable='';
        }

        id:number;
        questionNo:number;
        particulars:string;
        amount: number;
        isRequired:boolean;
        remark: string;
        variable: string;


    }

    export class newClient{

        constructor(){
                this.clientId=null;
                this.assignments=[new assignment()];
                // this.frequency= '';
                // this.fees= null;
                // this.budgetedContributionPercentage= null;
                // this.incentiveTo= '';
                this.branch= '';
                //this.appointmentDate= '';
                this.clientCreationDate= '';
                // this.dateOfNocSent= '';
                // this.engagementLetterDate= '';
                this.required=true;
                
        }

        clientId: number;
        assignments: assignment[];
        // frequency: string;
        // fees: number;
        // budgetedContributionPercentage: number;
        // incentiveTo: string;
        branch: string;
        // appointmentDate: any;
        clientCreationDate: any;
        // dateOfNocSent: any;
        // engagementLetterDate: any;
        required: boolean;
    }

    export class assignment
    {
        constructor(){
            this.id=null;
            this.assignmentId=null;
            this.frequency= '';
            this.fees= null;
            this.budgetedContributionPercentage= null;
            this.incentiveTo= null;
            this.appointmentDate= '';
            this.dateOfNocSent= '';
            this.engagementLetterDate= '';
            this.required=true;
            this.NOCrequired='';
            this.ELrequired='';
    
          
        }          
        id: number;
        assignmentId: number[];
        frequency: string;
        fees: number;
        budgetedContributionPercentage: number;
        incentiveTo: number;
        appointmentDate: any;
        dateOfNocSent: any;
        engagementLetterDate: any;
        required: boolean;
        NOCrequired: string;
        ELrequired: string;

        
    }

    // export class newAssignmentForExistingClient implements newAssignmentForExistingClient{

    //     constructor(clientId: number, assignmentId: number, frequency: string, fees: number,budgetedContributionPercentage: number,
    //         incentive: number,branch: string){
    //             this.clientId=clientId;
    //             this.assignmentId= assignmentId;
    //             this.frequency= frequency;
    //             this.fees= fees;
    //             this.budgetedContributionPercentage= budgetedContributionPercentage;
    //             this.incentive= incentive;
    //             this.branch= branch;
    
    //     }
    // }
    


    export class materialIssues
    {
        constructor(){
            this.answer='';
            this.client=null;
            this.description='';
            this.required=true;
        }
 
        answer: string;
        client: number;
        description: string;
        required: boolean; 
    }

    export class independence
    {

        constructor(){
            this.id=null;
            this.question='';
            this.answer='';
            this.remark='';
            this.dropDownList=[new dropDownList()];
            this.required=false;
            this.expectedValue='';
        }
        id: number;
        question: string;
        answer: string;
        remark: string;
        dropDownList: dropDownList[];
        required: boolean;
        expectedValue: string;

    }

    export class financialInterests{

        constructor(){
            this.loan=[new loan()]
            this.privateInvestment=[new privateInvestment()];
            //this.documents=[new documents()]
        }

        loan:loan[];
        privateInvestment:privateInvestment[];
        documents:documents[];
    }
    
    export class training{

        constructor(){
            this.requiredTraining=new requiredTrainingTypes();
            this.actualTraining=new trainingTypes();
            this.balanceTraining=new trainingTypes();

        }
        requiredTraining:requiredTrainingTypes;
        actualTraining:trainingTypes;
        balanceTraining:trainingTypes;
    }

    export class trainingTypes{

        constructor(){
            this.pgbPresenter=null;
            this.pgbInternal=null;
            this.cpe=null;
        }

        pgbPresenter: number;
        pgbInternal: number;
        cpe: number;
    }

    export class requiredTrainingTypes{

        constructor(){
            this.pgbPresenter=6;
            this.pgbInternal=9;
            this.cpe=30;
        }

        pgbPresenter: number;
        pgbInternal: number;
        cpe: number;
    }

    export class loan{

        constructor(){
            this.bank='';
            this.loanPurpose='';
            this.loanAmount=null;
            this.maturityDate='';
        }
        bank: string
        loanPurpose: string
        loanAmount: number
        maturityDate: any;
    }

    export class privateInvestment{

        constructor(){
            this.companyName=''
            this.investmentNature=''
            this.sharesCount=null;
            this.amount=null;
        }
        companyName: string
        investmentNature: string
        sharesCount: number
        amount: number
    }

    export class documents
    {
        constructor(){
            this.docId=null;
            this.docName='';
        }
        docId:number;
        docName:string;
    }

   
    export class engagementPerformance{

        constructor(){
            this.id=null;
            this.question='';
            this.answer='';
            this.remark='';
            this.dropDownList=[new dropDownList()];
            this.required=false;
            this.expectedValue='';
        }
        id: number;
        question: string;
        answer: string;
        remark: string;
        dropDownList: dropDownList[];
        required: boolean;
        expectedValue: string;
    }
    
    export class dropDownList{

        constructor(){
            this.id=null;
            this.value='';
        }
        id: number;
        value: string;
    }

    export class newAssignmentForExistingClient{
        
        constructor(){

            this.clientId=null;
            this.assignmentId=null;
            this.frequency='';
            this.fees=null;
            this.budgetedContributionPercentage=null;
            // this.incentive=null;
            // this.branch='';
        }
      clientId: number;
      assignmentId: number;
      frequency: string;
      fees: number;
      budgetedContributionPercentage: number;
    //   incentive: number;
    //   branch: string;
    
    }
    
    export class clientsOrAssignmentDiscontinued{
        
        constructor(){
        this.clientId=null;
        this.assignmentId=null;
        this.reason='';
        this.fees=null;
        }
        
        clientId: number;
        assignmentId: number;
        reason: string;
        fees: number;
    }
    
    export class feesIncreasedOrDecreased{

        constructor(){
        this.clientId=null;
        this.assignmentId=null;
        this.remark= '',
        this.oldFees=null;
        this.newFees=null;
        }
        clientId: number
        assignmentId: number
        remark: string
        oldFees: number
        newFees: number
    }
    
    export class potentialClientOrAssignment
    {
        constructor(){
            this.clientName='';
            this.assignmentId=null;
            this.frequency='';
            this.fees=null;
            this.connectName='';
            this.email1='';
            this.email2='';
        }
        clientName: string
        assignmentId: number
        frequency: string
        fees: number
        connectName: string
        email1: String
        email2: String
    }
    
    
   

